var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultiWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#004988"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.97 40.01C72.815 40 72.645 40 72.47 40H65.5375C59.86 40 55 44.34 55 50C55 55.66 59.86 60 65.5375 60H72.47C72.645 60 72.815 60 72.97 59.99C75.2775 59.85 77.3175 58.0975 77.49 55.6475C77.5 55.4875 77.5 55.315 77.5 55.155V44.845C77.5 44.685 77.5 44.5125 77.49 44.3525C77.3175 41.9025 75.2775 40.1525 72.97 40.01ZM64.9275 52.6675C66.3875 52.6675 67.5725 51.4725 67.5725 50C67.5725 48.525 66.3875 47.3325 64.9275 47.3325C63.465 47.3325 62.2775 48.5275 62.2775 50C62.2775 51.475 63.465 52.6675 64.9275 52.6675Z",
    fill: "#004988"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.85 40.005C72.85 37.0525 72.74 33.885 70.855 31.6175C70.6707 31.3954 70.4764 31.1818 70.2725 30.9775C68.4 29.1075 66.0275 28.2775 63.0975 27.8825C60.2475 27.5 56.61 27.5 52.015 27.5H46.735C42.14 27.5 38.5 27.5 35.65 27.8825C32.72 28.2775 30.3475 29.1075 28.475 30.9775C26.605 32.85 25.775 35.2225 25.38 38.1525C25 41.0025 25 44.64 25 49.235V49.515C25 54.11 25 57.75 25.3825 60.5975C25.7775 63.5275 26.6075 65.9 28.4775 67.7725C30.35 69.6425 32.7225 70.4725 35.6525 70.8675C38.5025 71.25 42.14 71.25 46.735 71.25H52.015C56.61 71.25 60.25 71.25 63.0975 70.8675C66.0275 70.4725 68.4 69.6425 70.2725 67.7725C70.7706 67.2729 71.2116 66.7195 71.5875 66.1225C72.7125 64.3225 72.8475 62.1175 72.8475 59.9975L72.4725 60H65.5375C59.86 60 55 55.66 55 50C55 44.34 59.86 40 65.5375 40H72.47C72.6 40 72.73 40 72.85 40.005Z",
    fill: "#004988"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M34.375 37.5C33.8777 37.5 33.4008 37.6975 33.0492 38.0492C32.6975 38.4008 32.5 38.8777 32.5 39.375C32.5 39.8723 32.6975 40.3492 33.0492 40.7008C33.4008 41.0525 33.8777 41.25 34.375 41.25H44.375C44.8723 41.25 45.3492 41.0525 45.7008 40.7008C46.0525 40.3492 46.25 39.8723 46.25 39.375C46.25 38.8777 46.0525 38.4008 45.7008 38.0492C45.3492 37.6975 44.8723 37.5 44.375 37.5H34.375Z",
    fill: "#ACD1EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiWallet);
export default __webpack_public_path__ + "static/media/multiWallet.f20c2090d72227e9fa9d1cde153ac5d5.svg";
export { ForwardRef as ReactComponent };